import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIndustry, faCoffee, faCogs, faPaw } from '@fortawesome/free-solid-svg-icons';
import React, { useState } from "react";
import logoo from '../logo/Al-Impex.png'; // Assuming this is your image for Who We Are
import imageWhoWeAre from '../logo/al-impexLogo.jpg'; // Assuming this is your image for Who We Are
import division1Image from '../logo/Zoetiss.jpg'; // Import your division images
import division2Image from '../logo/coffee.jpg';
import division3Image from '../logo/sunv.jpg';
import division4Image from '../logo/year_of_pulses.jpg';
import division5Image from '../logo/novus.jpg';
import division6Image from '../logo/delivery.jpg';
import division7Image from '../logo/Tender.png';
import '../../App.css'; // Ensure this is the correct path to your CSS file
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import web from '../logo/Alstaff.jpg'; // Import your division images
import webb from '../logo/intCoffee.jpg'; // Import your division images
import webbb from '../logo/anothercupping.jpg'; // Import your division images
import webbbb from '../logo/community.jpg'; // Import your division images
import webNo1 from '../logo/factory.jpg';
import webNo2 from '../logo/sunvitoD2D.jpg';
import webNo5 from '../logo/fabrica.jpg';
import webNoo from '../logo/distVan.mp4';
import webNoooo from '../logo/buna.png';
import novus from '../logo/anotherNovus.png';
import newImg from '../logo/new img.jpg';
import newImgg from '../logo/novussfactory.png';
import newImggg from '../logo/dasibseba.png';
import newImgggg from '../logo/zalaContainer.png';
import neww from '../logo/log.png';








import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';



function AboutUs() {
  const [expandedDivision, setExpandedDivision] = useState([]);
  const img=web;
  const [selectedCategory, setSelectedCategory] = useState("all"); // Category state
  const [backgroundImage, setBackgroundImage] = useState(division1Image);
  const [hoveredDivisionImage, setHoveredDivisionImage] = useState(web); // Default background image
  const [isAccordionOpen, setAccordionOpen] = useState(false);
  // const [hoveredDivisionImage, setHoveredDivisionImage] = React.useState(web); // Default background image
const [hoveredDivisionVideo, setHoveredDivisionVideo] = React.useState(null); // Default to no video


  // Toggle accordion state
  const toggleAccordion = () => {
    setAccordionOpen(!isAccordionOpen);
  };



  const divisions = [
    { id: 1, name: "Animal Health", image: division1Image },
    { id: 2, name: "FMCG", image: webNoo },
    { id: 3, name: "Novus Edible Oil", image: division5Image },
    { id: 4, name: "OPS", image: division4Image },
    { id: 5, name: "Wezam Coffee", image: division2Image },
    
  ];

  // Filtered divisions
  const filteredDivisions =
    selectedCategory === "all"
      ? divisions
      : divisions.filter((division) => division.category === selectedCategory);

  const toggleExpansion = (index) => {
    if (expandedDivision.includes(index)) {
      setExpandedDivision(expandedDivision.filter(item => item !== index));
    } else {
      setExpandedDivision([...expandedDivision, index]);
    }
  }; 

  const [activeSection, setActiveSection] = useState('mission');

  

  const isExpanded = (index) => {
    return expandedDivision.includes(index);
  };

  return (
    <div className="bg-gray-100">

<div>

</div>
      


<div className="mt-40 lg:mt-70">
  {/* About Us Section */}
  <div className="relative w-full h-[500px] md:h-[600px] flex items-center justify-center">
    {/* Background Image */}
    <div
      className="absolute inset-0 bg-cover bg-center"
      style={{
        backgroundImage: `url(${img})`, // Replace with the About Us banner image
        backgroundSize: "cover", // Ensures the image covers the entire area
        backgroundPosition: "center", // Centers the image
      }}
    ></div>

    {/* Semi-transparent Black Overlay */}
    <div className="absolute inset-0 bg-black bg-opacity-50"></div>

    {/* Smaller Transparent Content Box */}
    <div 
      className="relative z-10 px-8 py-2 max-w-xl rounded-lg shadow-lg text-center bg-white bg-opacity-40 backdrop-blur-md border border-white border-opacity-20 hover:bg-opacity-50 hover:shadow-xl hover:-translate-y-2 transition duration-300"
      style={{ height: 'auto', maxHeight: '700px' }} // Further reduced container height
    >
      <h1 className="text-2xl md:text-3xl font-bold text-green-800 leading-tight mb-2 mt-5">
        About Us 
      </h1>
      <p className="text-gray-200 mb-4 text-base md:text-lg">
        Discover our mission to promote excellence and innovation in dynamic markets. 
        We are committed to delivering impactful solutions that drive growth and transformation.
      </p>

      {/* Buttons Inside the Transparent Container */}
      <div className="flex justify-center gap-4 mb-5">
        {/* <a
          href="/about-us"
          className="bg-green-600 text-white py-2 px-4 mt-4 rounded hover:bg-green-700 transition inline-block"
        >
          Learn More
        </a> */}
        {/* <button className="bg-gray-200 text-gray-800 font-bold py-2 px-5 rounded-lg hover:bg-gray-300 text-lg">
          Watch the Webcast
        </button> */}
      </div>
    </div>
  </div>
</div>
 








<div className="container mx-auto px-8 lg:px-16 py-16 bg-gray-50 mt-32">
  {/* Our Story Section */}
  <div className="relative bg-gradient-to-r from-green-100 via-white to-green-50 py-16 px-8 rounded-lg shadow-lg">
    <div className="flex flex-col lg:flex-row items-center gap-16">
      {/* Text Section */}
      <div className="lg:w-1/2">
        <h2 className="text-4xl font-bold text-gray-800 text-center mb-12 border-b-4 border-green-600 inline-block">Our Story</h2>
        <p className="text-lg text-gray-700 leading-relaxed mb-6">
          For 26 years, AL-IMPEX has been at the forefront of Ethiopia’s economic growth, starting as a small commodity
          trading company with a mission to bridge market gaps for hardworking farmers. By championing Ethiopia's
          organic, high-quality agricultural products on the global stage, we uplifted smallholder farmers and fueled a
          revolution in the agricultural sector.
        </p>
        <p className="text-lg text-gray-700 leading-relaxed mb-6">
          The founder and CEO of Al-Impex played a pivotal role in establishing the Ethiopian Commodity Exchange (ECX), a landmark
          public-private initiative that connects surplus agricultural regions with areas facing shortages. This
          visionary contribution has revolutionized Ethiopia’s agricultural economy.
        </p>
        <p className="text-lg text-gray-700 leading-relaxed mb-6">
          Our journey led to innovations like Ethiopia’s first cash-and-carry center, a distribution network of over
          22,000 outlets, and the Route-to-Market (RTM) system. Five years ago, we expanded into fast-moving consumer
          goods (FMCG) manufacturing, agro-processing, and agricultural development, creating a diverse portfolio that
          includes edible oil factories, coffee processing plants, and logistics infrastructure.
        </p>
      </div>




     {/* Carousel Section */}
<div className="lg:w-3/4 xl:w-2/3">
  <div className="rounded-lg overflow-hidden shadow-md">
    <Carousel
      showThumbs={false}
      showIndicators={false}
      showStatus={false}
      infiniteLoop
      autoPlay
      interval={3000}
      showArrows={false}
    >
       {/* <div>
        <img
          src={neww}
          alt="Slide 4"
          className="object-cover w-full h-[350px] lg:h-[450px] xl:h-[500px] transition-transform duration-500 hover:scale-105"
        />
      </div> */}
      <div>
        <img
          src={webbb}
          alt="Slide 1"
          className="object-cover w-full h-[350px] lg:h-[450px] xl:h-[500px] transition-transform duration-500 hover:scale-105"
        />
      </div>
      <div>
        <img
          src={webbbb}
          alt="Slide 2"
          className="object-cover w-full h-[350px] lg:h-[450px] xl:h-[500px] transition-transform duration-500 hover:scale-105"
        />
      </div>
      <div>
        <img
          src={webNo2}
          alt="Slide 3"
          className="object-cover w-full h-[350px] lg:h-[450px] xl:h-[500px] transition-transform duration-500 hover:scale-105"
        />
      </div>
      <div>
        <img
          src={webNoooo}
          alt="Slide 4"
          className="object-cover w-full h-[350px] lg:h-[450px] xl:h-[500px] transition-transform duration-500 hover:scale-105"
        />
      </div>
      <div>
        <img
          src={novus}
          alt="Slide 4"
          className="object-cover w-full h-[350px] lg:h-[450px] xl:h-[500px] transition-transform duration-500 hover:scale-105"
        />
      </div>
      <div>
        <img
          src={newImgggg}
          alt="Slide 4"
          className="object-cover w-full h-[350px] lg:h-[450px] xl:h-[500px] transition-transform duration-500 hover:scale-105"
        />
      </div>
      <div>
        <img
          src={newImg}
          alt="Slide 4"
          className="object-cover w-full h-[350px] lg:h-[450px] xl:h-[500px] transition-transform duration-500 hover:scale-105"
        />
      </div>
      <div>
        <img
          src={newImgg}
          alt="Slide 4"
          className="object-cover w-full h-[350px] lg:h-[450px] xl:h-[500px] transition-transform duration-500 hover:scale-105"
        />
      </div>
    </Carousel>
  </div>
</div>

    </div>
  </div>

  {/* Our Why Section */}
  <div className="mt-16 bg-white py-16 px-8 rounded-lg shadow-lg">
    <h2 className="text-4xl font-bold text-gray-800 text-center mb-12 border-b-4 border-green-600 inline-block">
      Our Why
    </h2>

    {/* Why Cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">
      {/* Card 1 */}
      <div className="bg-green-50 p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow">
        <h3 className="text-2xl font-semibold text-green-800 mb-4">Economic Transformation</h3>
        <p className="text-gray-700">
          AL-IMPEX has been a transformative force in Ethiopia's economy for 26 years, evolving from a small trading
          business to a leader in agro-processing, manufacturing, and distribution.
        </p>
      </div>

      {/* Card 2 */}
      <div className="bg-green-50 p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow">
        <h3 className="text-2xl font-semibold text-green-800 mb-4">Addressing Market Failures</h3>
        <p className="text-gray-700">
          Founded to bridge market gaps, AL-IMPEX uplifted smallholder farmers by marketing Ethiopia's high-quality
          organic products internationally, fueling vital development projects.
        </p>
      </div>

      {/* Card 3 */}
      <div className="bg-green-50 p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow">
        <h3 className="text-2xl font-semibold text-green-800 mb-4">Advocacy and Promotion</h3>
        <p className="text-gray-700">
          AL-IMPEX promoted Ethiopian products globally through trade shows and transformative initiatives that benefit
          the nation.
        </p>
      </div>

      {/* Card 4 */}
      <div className="bg-green-50 p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow">
        <h3 className="text-2xl font-semibold text-green-800 mb-4">Visionary Leadership</h3>
        <p className="text-gray-700">
          The founder played a pivotal role in establishing the Ethiopian Commodity Exchange, facilitating efficient
          agricultural distribution.    
        </p>
      </div>
    </div>
  </div>
</div>













{/* Introduction Section */}
{/* <div className="container mx-auto p-8 mt-32  rounded-lg shadow-lg">
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start">
          <div className="lg:w-1/2 lg:pr-10 mb-8 lg:mb-0">
            <h2 className="text-4xl font-bold text-green-700 mb-4 ">Our Story</h2>
            <p className="text-lg text-gray-700">
            Founded in 2000, our company started as a small family business with a passion for agriculture and a vision to bring the 
          best of Ethiopia's oil seeds and pulses to the world. Over the years, we have grown into a major player in the export market, 
          known for our quality products and reliable service.
          <p className="text-lg text-gray-700">
          Today, we work with a network of dedicated farmers and partners to ensure that our products meet the highest standards of 
          quality and sustainability. We are proud of our heritage and committed to contributing to the prosperity of our country.
          </p>
          
            </p>
          </div>
          <div className="lg:w-1/2 flex justify-center">
            <img src={imageWhoWeAre} alt="Who We Are" className="rounded-lg shadow-lg" />
          </div>
        </div>
      </div>  */}



      





<div className="mb-32 mt-32">
      {/* Background Section */}
      <div
        className="relative h-screen bg-cover bg-center"
        style={{
          backgroundImage: `url(${hoveredDivisionImage})`,
          transition: "background-image 0.5s ease-in-out",
        }}
      >
        {/* Video Background */}
        {hoveredDivisionVideo === "distrVan" && (
          <video
            className="absolute inset-0 w-full h-full object-cover"
            autoPlay
            muted
            loop
            style={{
              zIndex: 0, // Ensure video stays on top of the background
              opacity: 1, // Make the video visible
              transition: "opacity 0.5s ease-in-out", // Smooth transition for video opacity
            }}
          >
            <source src={webNoo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}

        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Content */}
        <div className="absolute inset-0 flex flex-col justify-center items-center space-y-6 px-4">
          {/* Section Title */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white text-center">
            Our Divisions
          </h2>

          {/* Division List */}
          <div className="flex flex-col space-y-4 w-full items-center">
            {divisions.map((division) => (
              <Link
                key={division.id}
                to={`/division/${division.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-white text-sm sm:text-lg lg:text-xl font-semibold px-4 py-2 bg-green-700 bg-opacity-100 w-5/6 sm:w-3/4 lg:w-1/2 text-center rounded-md hover:bg-green-900 cursor-pointer transition-all"
                onMouseEnter={() => {
                  console.log("Hovered over:", division.name); // Debugging line
                  setHoveredDivisionImage(division.image); // Set background image for all divisions
                  if (division.name === "FMCG") {
                    setHoveredDivisionVideo("distrVan"); // Set video for "FMCG"
                  }
                }}
                onMouseLeave={() => {
                  setHoveredDivisionImage(web); // Reset background image on hover leave
                  setHoveredDivisionVideo(null); // Reset video on hover leave
                }}
              >
                {division.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>








<div className="flex justify-center space-x-8 text-center mt-12 mb-4 bg-gray-200">
  {/* Icon Section 1 */}
  {/* <div className="flex flex-col items-center transform hover:scale-110 transition-transform duration-300">
    <FontAwesomeIcon icon={faIndustry} size="3x" className="text-green-700 mb-4" />
    <h3 className="text-lg font-bold text-gray-800">Industry Expertise</h3>
    <p className="text-gray-600 text-sm mt-2">
      Years of excellence in the agriculture and export sector.
    </p>
  </div> */}

  {/* Icon Section 2 */}
  {/* <div className="flex flex-col items-center transform hover:scale-110 transition-transform duration-300">
    <FontAwesomeIcon icon={faCoffee} size="3x" className="text-green-700 mb-4" />
    <h3 className="text-lg font-bold text-gray-800">Quality Products</h3>
    <p className="text-gray-600 text-sm mt-2">
      Delivering the finest Ethiopian coffee and pulses worldwide.
    </p>
  </div> */}

  {/* Icon Section 3 */}
  {/* <div className="flex flex-col items-center transform hover:scale-110 transition-transform duration-300">
    <FontAwesomeIcon icon={faCogs} size="3x" className="text-green-700 mb-4" />
    <h3 className="text-lg font-bold text-gray-800">Innovation</h3>
    <p className="text-gray-600 text-sm mt-2">
      Continuously improving processes and services.
    </p>
  </div> */}

  {/* Icon Section 4 */}
  {/* <div className="flex flex-col items-center transform hover:scale-110 transition-transform duration-300">
    <FontAwesomeIcon icon={faPaw} size="3x" className="text-green-700 mb-4" />
    <h3 className="text-lg font-bold text-gray-800">Sustainability</h3>
    <p className="text-gray-600 text-sm mt-2">
      Promoting ethical and sustainable business practices.
    </p>
  </div> */}
</div>






<div className="w-auto bg-green-100 p-8 rounded-lg shadow-lg relative border-2 border-transparent mb-0 text-center mt-42">
          <h2 className="text-4xl font-semibold text-center text-green-900 mb-6">Get To Know Us</h2>
          <p className="text-gray-700 text-lg mb-6">
          Get in Touch
Have questions or want to learn more about us? We’d love to hear from you!
Feel free to reach out through our contact form
          </p>
          <Link to="/contact-us" className="bg-green-500 text-white px-6 py-3 rounded-lg shadow-md hover:bg-green-600 transition duration-300">Contact Us</Link>
        </div>
      

      
    </div>
  );
}

export default AboutUs; 